/**
 * Let's us reference things as properties rather than magic strings.
 */
export interface IConstants {
  readonly unassignedUnitNumber: string;
  readonly emailRegex: RegExp;
  readonly unitNumberRegex: RegExp;
  readonly phoneRegex: RegExp;
}

/**
 * The actual values of the constants in our system.
 */
export const Constants: IConstants = {
  // Our system requires unit numbers, but sometimes they don't have one yet.  So if the ward doesn't have one, we'll use this unit number as a placeholder one until
  // they have a good one.  If we get a ward with this number, we won't show the unit number to them at all.
  unassignedUnitNumber: '999999999',

  // this regex came from Angular's source code; we're using it over a Validator.email because that one had a bug and treated it as a required field
  emailRegex: /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/,

  // allow our unassigned unit number or a real unit number
  unitNumberRegex: /^999999999$|^[0-9]{1,7}$/,

  // allow all numbers or formatted as ###-###-#### or (###) ###-####
  phoneRegex: /^[0-9]{10}$|^[0-9]{3}-[0-9]{3}-[0-9]{4}$|^\({0,1}[0-9]{3}\){0,1} {0,1}[0-9]{3}-[0-9]{4}$|^\d{3} \d{3} \d{4}$/
};
